import { atom } from 'jotai';

// App state
export type AppState = {
  isLoading: boolean;
  error: string | null;
};

// Initial state
const initialState: AppState = {
  isLoading: false,
  error: null,
};

// Atoms
export const appStateAtom = atom<AppState>(initialState);
export const isLoadingAtom = atom(
  (get) => get(appStateAtom).isLoading,
  (get, set, isLoading: boolean) => {
    set(appStateAtom, {
      ...get(appStateAtom),
      isLoading,
    });
  }
);

export const errorAtom = atom(
  (get) => get(appStateAtom).error,
  (get, set, error: string | null) => {
    set(appStateAtom, {
      ...get(appStateAtom),
      error,
    });
  }
);
